export default __webpack_public_path__ + "static/media/maintanceReports.4a976839.svg";